import { render } from "./CoolBar.vue?vue&type=template&id=8a816196&lang=pug"
import script from "./CoolBar.vue?vue&type=script&lang=js"
export * from "./CoolBar.vue?vue&type=script&lang=js"

import "./CoolBar.vue?vue&type=style&index=0&id=8a816196&lang=scss"
script.render = render

export default script